import { yupResolver } from '@hookform/resolvers/yup';
import { useForm, type Resolver } from 'react-hook-form';
import { Renter } from '@/utils/types/renter.interface';
import { RentCoverageTypes, SecurityDepositTypes } from '@/constants';
import { inviteLeaseDetailsSchema } from '../invite-lease-details.schema';

interface UseInviteLeaseDetailsFormProps {
  selfEnrolledSDRLimit?: number;
  customCoverageDisabled?: boolean;
  useNewCoveragesOnLandlordInvite?: boolean;
}

export const useInviteLeaseDetailsForm = ({
  selfEnrolledSDRLimit,
  customCoverageDisabled,
  useNewCoveragesOnLandlordInvite,
}: UseInviteLeaseDetailsFormProps) => {
  const {
    control,
    handleSubmit,
    setError,
    watch,
    formState,
    setValue,
    trigger,
    resetField,
    clearErrors,
  } = useForm<Renter>({
    mode: 'all',
    resolver: yupResolver(
      inviteLeaseDetailsSchema(
        selfEnrolledSDRLimit,
        customCoverageDisabled,
        useNewCoveragesOnLandlordInvite,
      ),
    ) as Resolver<Renter>,
    defaultValues: {
      apartmentNumber: '',
      approvalStatus: '',
      customCoverage: false,
      applicantEmails: [{ value: '' }],
      securityDepositCoverage: SecurityDepositTypes.CompanyDefault,
      rentCoverage: RentCoverageTypes.CompanyDefault,
    },
    shouldUnregister: true,
  });

  return {
    control,
    formState,
    setError,
    handleSubmit,
    watch,
    setValue,
    trigger,
    resetField,
    clearErrors,
  };
};
